/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCatchEvent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 .586 9.414 4H13v5h2v6h-2v5H9.414L6 23.414 1.586 19 6 14.586 9.414 18H11v-3H9V9h2V6H9.414L6 9.414 1.586 5zm0 16.829L4.415 19 6 20.585 7.585 19zM12.999 11h-2v2h2zm8.294-9.707 1.414 1.414L19.414 6H22v2h-6V2h2v2.586zM6 3.415 4.415 5 6 6.585 7.585 5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCatchEvent as CatchEvent };
